/* LUMĒNE SPORT — theme.js — built from scratch */

/* ── Page reveal ── */
(function revealPage() {
  document.body.classList.add('ls-ready');
})();
setTimeout(function() { document.body.classList.add('ls-ready'); }, 600);

window.addEventListener('pageshow', function(e) {
  if (e.persisted) {
    document.body.classList.add('ls-ready');
    refreshCartBadge();
  }
});

/* ── DOMContentLoaded init ── */
document.addEventListener('DOMContentLoaded', function() {
  safeRun(initHeaderScroll);
  safeRun(initMenu);
  safeRun(initGallery);
  safeRun(initPheroGallery);
  safeRun(initSwatches);
  safeRun(initSizes);
  safeRun(initLightbox);
  safeRun(initReveal);
  safeRun(initCartBadge);
  safeRun(initATC);
  safeRun(initBuyNow);
  safeRun(initCartPage);
  safeRun(initVideos);
  safeRun(initImageFade);
});

function safeRun(fn) {
  try { fn(); } catch(e) { /* silent */ }
}

/* ── Safe video play ── */
function safePlay(vid) {
  if (!vid) return;
  try {
    vid.muted = true;
    var p = vid.play();
    if (p && p.catch) p.catch(function() {});
  } catch(e) {}
}

/* ── Autoplay all videos ── */
function initVideos() {
  document.querySelectorAll('video[autoplay]').forEach(function(vid) {
    safePlay(vid);
  });
  document.addEventListener('touchstart', function() {
    document.querySelectorAll('video[autoplay]').forEach(safePlay);
  }, { once: true, passive: true });
}

/* ── Image fade-in ── */
function initImageFade() {
  document.querySelectorAll('img').forEach(function(img) {
    if (img.complete) return;
    img.style.opacity = '0';
    img.style.transition = 'opacity .5s ease';
    img.addEventListener('load', function() { img.style.opacity = '1'; }, { once: true });
    img.addEventListener('error', function() { img.style.opacity = '1'; }, { once: true });
  });
}

/* ── Header scroll shadow ── */
function initHeaderScroll() {
  var hdr = document.querySelector('.hdr');
  if (!hdr) return;
  function tick() { hdr.classList.toggle('scrolled', window.scrollY > 30); }
  window.addEventListener('scroll', tick, { passive: true });
  tick();
}

/* ── Hamburger menu ── */
function initMenu() {
  var btn      = document.getElementById('menuBtn');
  var overlay  = document.getElementById('navOverlay');
  var backdrop = document.getElementById('navBackdrop');
  var closeBtn = document.getElementById('menuClose');
  if (!btn || !overlay) return;

  function open() {
    overlay.classList.add('open');
    backdrop && backdrop.classList.add('open');
    btn.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('open');
    backdrop && backdrop.classList.remove('open');
    btn.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  backdrop && backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
}

/* ── Back button (browser history) ── */
function goBack() {
  try {
    if (document.referrer && document.referrer.indexOf(location.hostname) !== -1) {
      history.back();
    } else {
      window.location.href = '/collections/all';
    }
  } catch(e) { window.location.href = '/collections/all'; }
}
window.goBack = goBack;

/* ═══════════════════════════════════════════════════
   SUITE CELESTE GALLERY (.hero__slide)
═══════════════════════════════════════════════════ */
function initGallery() {
  var slides  = Array.from(document.querySelectorAll('.hero__slide'));
  var dots    = Array.from(document.querySelectorAll('.hero__dot'));
  var prevBtn = document.getElementById('heroPrev');
  var nextBtn = document.getElementById('heroNext');
  if (!slides.length) return;

  var current = 0;

  function getVid(slide) {
    return slide ? slide.querySelector('video') : null;
  }

  function goTo(index) {
    var total = slides.length;
    index = ((index % total) + total) % total;
    if (index === current) return;

    var prevVid = getVid(slides[current]);
    if (prevVid) try { prevVid.pause(); } catch(e) {}

    slides.forEach(function(s, i) { s.classList.toggle('active', i === index); });
    dots.forEach(function(d, i)   { d.classList.toggle('active', i === index); });
    current = index;

    var curSlide = slides[current];
    var vid = getVid(curSlide);
    if (vid) { try { vid.currentTime = 0; } catch(e) {} safePlay(vid); }

    var isVideo = curSlide && curSlide.dataset.type === 'video';
    var color   = curSlide && curSlide.dataset.color;
    syncSwatches(isVideo, color);
  }

  /* initial state */
  if (slides[0]) slides[0].classList.add('active');
  if (dots[0])   dots[0].classList.add('active');
  var firstVid = getVid(slides[0]);
  if (firstVid) {
    safePlay(firstVid);
    document.addEventListener('touchstart', function() { safePlay(firstVid); }, { once: true, passive: true });
  }

  prevBtn && prevBtn.addEventListener('click', function() { goTo(current - 1); });
  nextBtn && nextBtn.addEventListener('click', function() { goTo(current + 1); });
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.index) || 0); });
  });

  /* swipe */
  addSwipe(document.getElementById('heroDisplay'), function(dir) { goTo(current + dir); });

  window._galleryGoTo = goTo;
}

/* ═══════════════════════════════════════════════════
   PHERO GALLERY (Amélie / Marta / Claire — .phero__slide)
═══════════════════════════════════════════════════ */
function initPheroGallery() {
  var slides  = Array.from(document.querySelectorAll('.phero__slide'));
  var dots    = Array.from(document.querySelectorAll('.hero__dot'));
  var prevBtn = document.getElementById('heroPrev');
  var nextBtn = document.getElementById('heroNext');
  if (!slides.length) return;

  var current = 0;

  function getVid(slide) {
    return slide ? slide.querySelector('video') : null;
  }

  function goTo(index) {
    var total = slides.length;
    index = ((index % total) + total) % total;
    if (index === current) return;

    var prevVid = getVid(slides[current]);
    if (prevVid) try { prevVid.pause(); } catch(e) {}

    slides.forEach(function(s, i) { s.classList.toggle('active', i === index); });
    dots.forEach(function(d, i)   { d.classList.toggle('active', i === index); });
    current = index;

    var curSlide = slides[current];
    var vid = getVid(curSlide);
    if (vid) { try { vid.currentTime = 0; } catch(e) {} safePlay(vid); }

    var isVideo = curSlide && curSlide.dataset.type === 'video';
    var color   = curSlide && curSlide.dataset.color;
    syncSwatches(isVideo, color);
  }

  if (slides[0]) slides[0].classList.add('active');
  if (dots[0])   dots[0].classList.add('active');
  var firstVid = getVid(slides[0]);
  if (firstVid) {
    safePlay(firstVid);
    document.addEventListener('touchstart', function() { safePlay(firstVid); }, { once: true, passive: true });
  }

  prevBtn && prevBtn.addEventListener('click', function() { goTo(current - 1); });
  nextBtn && nextBtn.addEventListener('click', function() { goTo(current + 1); });
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.index) || 0); });
  });

  addSwipe(document.getElementById('heroDisplay'), function(dir) { goTo(current + dir); });

  window._pheroGoTo = goTo;
}

/* ── Sync swatches when gallery changes ── */
function syncSwatches(isVideo, color) {
  var swatches   = document.querySelectorAll('.swatch');
  var colorLabel = document.getElementById('color-name');
  swatches.forEach(function(sw) {
    if (isVideo) {
      sw.classList.toggle('on', sw.classList.contains('swatch--video'));
    } else {
      sw.classList.toggle('on', sw.dataset.color === color);
    }
  });
  if (colorLabel) {
    if (isVideo) {
      colorLabel.textContent = 'Video';
    } else {
      var activeSw = color ? document.querySelector('.swatch[data-color="' + color + '"]') : null;
      if (activeSw) colorLabel.textContent = activeSw.dataset.name || color;
    }
  }
}

/* ── Swipe helper ── */
function addSwipe(el, callback) {
  if (!el) return;
  var startX = 0, startY = 0;
  el.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });
  el.addEventListener('touchend', function(e) {
    var dx = startX - e.changedTouches[0].clientX;
    var dy = startY - e.changedTouches[0].clientY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      callback(dx > 0 ? 1 : -1);
    }
  }, { passive: true });
}

/* ═══════════════════════════════════════════════════
   SWATCHES
═══════════════════════════════════════════════════ */
function initSwatches() {
  var swatches   = document.querySelectorAll('.swatch');
  var colorLabel = document.getElementById('color-name');
  if (!swatches.length) return;

  swatches.forEach(function(sw) {
    sw.addEventListener('click', function() {
      swatches.forEach(function(s) { s.classList.remove('on'); });
      sw.classList.add('on');
      if (colorLabel) colorLabel.textContent = sw.dataset.name || '';

      var slideIndex = parseInt(sw.dataset.slide);
      if (!isNaN(slideIndex)) {
        if (window._galleryGoTo) window._galleryGoTo(slideIndex);
        if (window._pheroGoTo)   window._pheroGoTo(slideIndex);
      }
      updateVariant();
    });
  });
}

/* ═══════════════════════════════════════════════════
   SIZES
═══════════════════════════════════════════════════ */
function initSizes() {
  var btns  = document.querySelectorAll('.sz');
  var label = document.getElementById('size-name');
  if (!btns.length) return;

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      btns.forEach(function(b) { b.classList.remove('on'); });
      btn.classList.add('on');
      if (label) label.textContent = btn.dataset.size || '';
      updateVariant();
    });
  });
}

/* ── Variant matching ── */
function updateVariant() {
  var variants = window._pv;
  if (!variants || !variants.length) return;

  var colorEl = document.querySelector('.swatch.on:not(.swatch--video)');
  var sizeEl  = document.querySelector('.sz.on');
  var selColor = colorEl ? (colorEl.dataset.name || colorEl.dataset.color || '') : '';
  var selSize  = sizeEl  ? (sizeEl.dataset.size || '') : '';

  var variantInput = document.getElementById('variant-id');
  var atcBtn       = document.getElementById('atc-btn');
  if (!variantInput) return;

  var match = null;

  /* Try exact color + size match */
  if (selColor && selSize) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = [v.option1, v.option2, v.option3].filter(Boolean).map(function(o) { return o.toLowerCase(); });
      if (opts.indexOf(selColor.toLowerCase()) !== -1 && opts.indexOf(selSize.toLowerCase()) !== -1) {
        match = v; break;
      }
    }
  }

  /* Fallback: size only */
  if (!match && selSize) {
    for (var j = 0; j < variants.length; j++) {
      var vj = variants[j];
      var optsj = [vj.option1, vj.option2, vj.option3].filter(Boolean).map(function(o) { return o.toLowerCase(); });
      if (optsj.indexOf(selSize.toLowerCase()) !== -1) { match = vj; break; }
    }
  }

  /* Fallback: first available */
  if (!match) {
    for (var k = 0; k < variants.length; k++) {
      if (variants[k].available !== false) { match = variants[k]; break; }
    }
    if (!match) match = variants[0];
  }

  if (match) {
    variantInput.value = match.id;
    if (atcBtn) {
      atcBtn.disabled = (match.available === false);
      if (match.available === false) {
        atcBtn.textContent = 'Sold Out';
      }
    }
  }
}

/* ═══════════════════════════════════════════════════
   LIGHTBOX
═══════════════════════════════════════════════════ */
function initLightbox() {
  var lightbox = document.getElementById('lightbox');
  var lbImg    = document.getElementById('lightboxImg');
  var lbClose  = document.getElementById('lightboxClose');
  if (!lightbox || !lbImg) return;

  var images = [], lbIndex = 0;
  var slideSelector = '.hero__slide:not([data-type="video"]), .phero__slide:not([data-type="video"])';

  function buildImages() {
    images = Array.from(document.querySelectorAll(slideSelector))
      .map(function(s) { return s.querySelector('img'); })
      .filter(Boolean);
  }

  function openLightbox(index) {
    buildImages();
    lbIndex = index;
    showImage();
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function showImage() {
    var img = images[lbIndex];
    if (!img) return;
    lbImg.style.opacity = '0';
    setTimeout(function() {
      lbImg.src = img.src;
      lbImg.alt = img.alt || '';
      lbImg.style.opacity = '1';
    }, 100);
  }

  function closeLightbox() {
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll(slideSelector).forEach(function(slide, i) {
    slide.addEventListener('click', function() { openLightbox(i); });
  });

  lbClose && lbClose.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function(e) { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', function(e) {
    if (!lightbox.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft')  { lbIndex = (lbIndex - 1 + images.length) % images.length; showImage(); }
    if (e.key === 'ArrowRight') { lbIndex = (lbIndex + 1) % images.length; showImage(); }
  });
}

/* ═══════════════════════════════════════════════════
   SCROLL REVEAL
═══════════════════════════════════════════════════ */
function initReveal() {
  var els = Array.from(document.querySelectorAll('.r, .coll-card, .colls-card, .contact-info__block'));
  if (!els.length) return;
  if (!window.IntersectionObserver) {
    els.forEach(function(el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function(el) { io.observe(el); });
}

/* ═══════════════════════════════════════════════════
   CART BADGE
═══════════════════════════════════════════════════ */
function initCartBadge() {
  refreshCartBadge();
}

function refreshCartBadge() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badge = document.querySelector('.cart-badge');
      if (!badge) return;
      badge.textContent = cart.item_count;
      badge.classList.toggle('visible', cart.item_count > 0);
    })
    .catch(function() {});
}

/* ── Toast ── */
function showToast(msg) {
  var toast = document.getElementById('atcToast');
  var msgEl = document.getElementById('atcToastMsg');
  if (!toast) return;
  if (msgEl) msgEl.textContent = msg || 'Added to cart';
  toast.classList.add('show');
  setTimeout(function() { toast.classList.remove('show'); }, 3500);
}

/* ── Shake an element to signal missing selection ── */
function shakeEl(selector) {
  var el = document.querySelector(selector);
  if (!el) return;
  el.classList.remove('ls-shake');
  void el.offsetWidth; /* reflow */
  el.classList.add('ls-shake');
  el.style.outline = '1px solid ' + getComputedStyle(document.documentElement).getPropertyValue('--terra').trim();
  setTimeout(function() { el.style.outline = ''; el.classList.remove('ls-shake'); }, 1000);
}

/* ── Build fetch payload ── */
function buildPayload(variantId, colorEl, sizeEl) {
  var props = {};
  if (colorEl) props['Color'] = colorEl.dataset.name || colorEl.dataset.color || '';
  if (sizeEl)  props['Size']  = sizeEl.dataset.size  || '';
  var img = colorEl ? (colorEl.dataset.image || '') : '';
  if (img) props['_image'] = img;
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, properties: props })
  };
}

/* ═══════════════════════════════════════════════════
   ADD TO CART
═══════════════════════════════════════════════════ */
function initATC() {
  var form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    /* Size is required */
    var sizeEl = document.querySelector('.sz.on');
    if (!sizeEl) { shakeEl('.sizes'); return; }

    var variantInput = document.getElementById('variant-id');
    if (!variantInput || !variantInput.value) {
      /* fallback: pick first available variant */
      if (window._pv && window._pv.length) {
        var fv = window._pv.find(function(v) { return v.available !== false; }) || window._pv[0];
        if (variantInput) variantInput.value = fv.id;
      } else { return; }
    }

    var colorEl = document.querySelector('.swatch.on:not(.swatch--video)');
    var btn     = document.getElementById('atc-btn');
    var origTxt = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', buildPayload(variantInput.value, colorEl, sizeEl))
      .then(function(r) { if (!r.ok) throw r; return r.json(); })
      .then(function() {
        if (btn) {
          btn.textContent = '✓ Added';
          btn.disabled = false;
          setTimeout(function() { btn.textContent = origTxt; }, 2500);
        }
        refreshCartBadge();
        var colorName = colorEl ? (colorEl.dataset.name || '') : '';
        var sizeName  = sizeEl.dataset.size || '';
        var parts = [colorName, sizeName].filter(Boolean);
        showToast(parts.length ? parts.join(' · ') : 'Added to cart');
      })
      .catch(function() {
        if (btn) { btn.textContent = 'Try Again'; btn.disabled = false; }
      });
  });
}

/* ═══════════════════════════════════════════════════
   BUY NOW
═══════════════════════════════════════════════════ */
function initBuyNow() {
  var btn = document.getElementById('buy-now-btn');
  if (!btn) return;

  btn.addEventListener('click', function() {
    /* Size is required */
    var sizeEl = document.querySelector('.sz.on');
    if (!sizeEl) { shakeEl('.sizes'); return; }

    var variantInput = document.getElementById('variant-id');
    var variantId = '';

    if (variantInput && variantInput.value) {
      variantId = variantInput.value;
    } else if (window._pv && window._pv.length) {
      /* pick best available variant for selected size */
      var selSize = sizeEl.dataset.size.toLowerCase();
      var found = null;
      for (var i = 0; i < window._pv.length; i++) {
        var v = window._pv[i];
        var opts = [v.option1, v.option2, v.option3].filter(Boolean).map(function(o) { return o.toLowerCase(); });
        if (opts.indexOf(selSize) !== -1 && v.available !== false) { found = v; break; }
      }
      if (!found) found = window._pv[0];
      variantId = String(found.id);
    }

    if (!variantId) { shakeEl('.sizes'); return; }

    var origTxt = btn.textContent;
    btn.textContent = 'Loading…';
    btn.disabled = true;

    var colorEl = document.querySelector('.swatch.on:not(.swatch--video)');

    fetch('/cart/add.js', buildPayload(variantId, colorEl, sizeEl))
      .then(function(r) { if (!r.ok) throw r; return r.json(); })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function() {
        btn.textContent = origTxt;
        btn.disabled = false;
      });
  });
}

/* ═══════════════════════════════════════════════════
   CART PAGE (qty / remove)
═══════════════════════════════════════════════════ */
function initCartPage() {
  var cartItems = document.querySelectorAll('.cart-item[data-key]');
  if (!cartItems.length) return;

  var totalEl = document.getElementById('cartTotal');

  function callChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r) { return r.json(); });
  }

  function fmtPrice(cents) {
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateBadge(n) {
    var badge = document.querySelector('.cart-badge');
    if (!badge) return;
    badge.textContent = n;
    badge.classList.toggle('visible', n > 0);
  }

  cartItems.forEach(function(row) {
    var key     = row.dataset.key;
    var qtyEl   = row.querySelector('.cart-qty__num');
    var priceEl = row.querySelector('.cart-item__line-price');

    var incBtn = row.querySelector('[data-action="inc"]');
    var decBtn = row.querySelector('[data-action="dec"]');
    var remBtn = row.querySelector('[data-action="remove"]');

    if (incBtn) {
      incBtn.addEventListener('click', function() {
        var q = parseInt(qtyEl.textContent, 10) + 1;
        qtyEl.textContent = q;
        callChange(key, q).then(function(cart) {
          if (totalEl) totalEl.textContent = fmtPrice(cart.total_price);
          var li = cart.items.find(function(x) { return x.key === key; });
          if (priceEl && li) priceEl.textContent = fmtPrice(li.line_price);
          updateBadge(cart.item_count);
        });
      });
    }

    if (decBtn) {
      decBtn.addEventListener('click', function() {
        var q = parseInt(qtyEl.textContent, 10) - 1;
        if (q <= 0) { removeRow(row, key); return; }
        qtyEl.textContent = q;
        callChange(key, q).then(function(cart) {
          if (totalEl) totalEl.textContent = fmtPrice(cart.total_price);
          var li = cart.items.find(function(x) { return x.key === key; });
          if (priceEl && li) priceEl.textContent = fmtPrice(li.line_price);
          updateBadge(cart.item_count);
        });
      });
    }

    if (remBtn) {
      remBtn.addEventListener('click', function() { removeRow(row, key); });
    }
  });

  function removeRow(row, key) {
    row.classList.add('removing');
    callChange(key, 0).then(function(cart) {
      row.remove();
      if (totalEl) totalEl.textContent = fmtPrice(cart.total_price);
      updateBadge(cart.item_count);
      if (cart.item_count === 0) location.reload();
    });
  }
}
